import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { history } from '../../../store';

import './style.css';

class LockPopup extends Component {

  constructor(props) {
    super(props);
  }

  close() {
    this.setState((prev) =>{
      return { show: false };
    });

    if (this.props.route) {
      history.push(this.props.route);
    }
  }

  render() {
    return (
      <div className="modal-container">
        <Modal
          show={true}
          container={this}
          aria-labelledby="contained-modal-title" >
          <Modal.Body>
            Your account has now been locked to keep it secure.
            Please <Link to="/contact">click here to contact us</Link> so that we can help you access your account
            <br />
            <Button className="grey-ghost-btn" onClick={this.close.bind(this)}>CLOSE</Button>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default LockPopup;



// WEBPACK FOOTER //
// ./src/components/auth/lock-popup/index.jsx